"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formRules = exports.defaultFormData = void 0;
var defaultFormData = exports.defaultFormData = {
  menuName: '',
  // 菜单名称
  menuPic: '',
  // 菜单图片
  menuUrl: '',
  // 跳转链接
  sort: 0,
  status: 0 // 是否启用
};
var formRules = exports.formRules = {
  menuName: [{
    required: true,
    trigger: ['blur', 'change'],
    message: '请输入菜单名称'
  }],
  menuPic: [{
    required: true,
    trigger: ['blur', 'change'],
    message: '请选择菜单图片'
  }],
  menuUrl: [{
    required: true,
    trigger: ['blur', 'change'],
    message: '请输入跳转链接'
  }],
  sort: [{
    required: true,
    trigger: ['blur', 'change'],
    message: '请输入排序值'
  }]
};